export default {
	"item.MallOrderConfirmationPageCouponRetentionPopUpWindowConfirmationButton": "Mall order confirmation page_Coupon retention pop-up window_Confirmation button",
	"item.AcceptAndUse": "Accept and use",
	"item.PickUpFailed": "Pick-up failed",
	"item.NoProductsSelected": "No products selected",
	"item.NoAddressSelected": "No address selected",
	"item.IfYouAreBuyingInInstallmentsPleaseSelectTheNumberOfInstallments": "If you are buying in installments, please select the number of installments",
	"item.MarketplaceOrderConfirmationPagebottomButton": "Marketplace order confirmation page_bottom button",
	"item.prompt": "prompt",
	"item.UntieTheBindingForTheTimeBeing": "Untie the binding for the time being",
	"item.UnbindTheAccount": "Unbind the account",
	"item.AccordingToTheRequirementsOfNationalPoliciesTheExpressMailSentToTaiwanNeedsToFillInTheCertificateNumberPleaseFillIn": "According to the requirements of national policies, the express mail sent to Taiwan needs to fill in the certificate number, please fill in",
	"item.Cancel": "Cancel",
	"item.GoReplenishment": "Go replenishment",
	"item.SorryThePriceHasChanged": "Sorry, the price has changed!",
	"item.SorryFailedToCreateOrder": "Sorry, failed to create order!",
	"item.RepeatPurchasePrompts": "Repeat purchase prompts",
	"item.ignore": "ignore",
	"item.ViewOrders": "View orders",
	"item.WeChatCanEnterTheAccessAfterAuthorizationRequestAuthorization": "WeChat can enter the access after authorization, request authorization...",
	"item.OnTheMarketplaceOrderConfirmationPageClickOnAddress": "On the marketplace order confirmation page, click on address",
	"item.MarketplaceOrderConfirmationPagecouponClick": "Marketplace order confirmation page_coupon click",
	"item.Removed": "Removed",
	"item.SoldOut": "Sold out",
	"item.InsufficientGrowthBeans": "Insufficient growth beans",
	"item.RedeemNow": "Redeem now",
	"item.SubmitYourOrder": "Submit your order",
	"item.ParameterError": "Parameter error!",
	"item.FirstInstalmentCredit": "First instalment credit",
	"item.PleaseSelectAnAvailableCoupon": "Please select an available coupon",
	"item.NoOffersAvailable": "No offers available",
	"item.ContinuousPackages": "Continuous packages",
	"item.Every": ": Every",
	"item.ChargesAreDeducted": "Charges are deducted",
	"item.head": "head",
	"item.ImmediatelyReduced": "Immediately reduced",
	"item.ThereIsNoDeliveryAddress": "There is no delivery address",
	"item.PleaseAddAShippingAddress": "Please add a shipping address",
	"item.CallItOfficial": "Call it official",
	"item.Selected": "Selected:",
	"item.DeliveryMethod": "Delivery method",
	"item.ExpressDelivery": "Express delivery",
	"item.Coupons": "Coupons",
	"item.use": "use",
	"item.Deductions": "Deductions",
	"item.GrowBeans": "Grow beans",
	"item.RemainingGrowingBeans": "Remaining growing beans:",
	"item.TotalPayableForTheCurrentPeriod": "Total payable for the current period",
	"item.TheAmountOfTheItem": "The amount of the item",
	"item.freight": "freight",
	"item.total": "total",
	"item.FlowerStaging": "Flower staging",
	"item.divide": "divide",
	"item.timeLimit": "time limit",
	"item.Total¥": "Total ¥",
	"item.HandlingFee¥": "Handling fee ¥ ",
	"item.PleaseSelectTheStagingType": "Please select the staging type",
	"item.Total": "Total:",
	"item.InstallmentTotal": "Installment total:",
	"item.Premium": "Premium:",
	"item.PerIssue": "/ Per issue",
	"item.GotIt": "Got it",
	"item.ToPayForThisOrderPleasePayInTheOrderLogisticsOfTheCallPublicAccount": "To pay for this order, please pay in the order logistics of the [Call] public account",
	"item.GrowingBeansUsageRules": "Growing beans usage rules",
	"item.ProductDetailPageRetentionPopUpExposure": "Product Detail Page_Retention Pop-up Exposure",
	"item.shoppingCentre": "shopping centre",
	"item.ProductDetailPageRetainPopUpContentButtonClick": "Product detail page_Retain pop-up content button click",
	"item.other": "other",
	"item.ClickTheBottomButtonOnTheProductDetailPageRetentionPopUpWindow": "Click the Bottom button on the Product Detail Page_Retention pop-up window",
	"item.abandon": "abandon"
}